import {
  ApplicationRef,
  Component,
  ComponentRef,
  OnDestroy,
  OnInit
} from '@angular/core';
import { OrderDiscountBannerComponent } from '@components/order-discount-banner/order-discount-banner.component';
import { createDiscountBannerComponent } from '@core/helpers';
import { DiscountBannerService, SafePlayService } from '@core/services';
import { InitService } from '@core/services/init/init.service';
import { Store } from '@ngxs/store';
import { SettingsState } from '@store/settings/settings.state';
import { projectData } from './project-data';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  private bannerRef!: ComponentRef<OrderDiscountBannerComponent>;
  private bannerEl!: HTMLElement;

  constructor(
    public initService: InitService,
    private safePlayService: SafePlayService,
    private appRef: ApplicationRef,
    private store: Store,
    private discountBannerService: DiscountBannerService
  ) {
    this.initService.init({ projectData });
  }

  ngOnInit() {
    this.safePlayService.handleScheduledMessages(
      'button_border-grey',
      'my-account/safe-playing'
    );

    this.handleDiscountBanner();
  }

  ngOnDestroy() {
    if (this.bannerRef) {
      this.appRef.detachView(this.bannerRef.hostView);
      this.bannerRef.destroy();
      this.discountBannerService.clear();
    }
  }

  private handleDiscountBanner() {
    const banner = createDiscountBannerComponent(this.appRef);
    this.bannerRef = banner.ref;
    this.bannerEl = banner.element;

    this.discountBannerService.init(
      this.bannerEl,
      this.store.select(SettingsState.orderDiscount)
    );
  }
}
